import React, { useState, useEffect } from "react";
import EnhancedSearchModal from "./EnhancedSearchModal";

import FadeLoader from "react-spinners/FadeLoader";
import Accordion from "@material-ui/core/Accordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";

import { overrideSidebar } from "@safecv/shared/sharedFunction";
import { getEnhancedSearchResults } from "../../../Actions/postActions";

const EnchancedSearch = (props) => {
  const { jobId,
    selectedEnhancedSearch,
    setSelectedEnhancedSearch,
    setSelectedGroupEnhancedSearch 
  } = props;

  const [sectionArray, setSectionArray] = useState(null);
  const [keywordArray, setKeywordArray] = useState(null);
  const [sectionCountArray, setSectionCountArray] = useState(null);

  const [expandedOuter, setExpandedOuter] = React.useState(false);
  const [expandedInner, setExpandedInner] = React.useState(false);

  const [enhancedSearchResult, setEnhancedSearchResult] = useState(null);
  const [enhancedSearchLoading, setEnhancedSearchLoading] = useState(false);

  useEffect(() => {
    async function fetchEnhancedSearchResults() {
      const results = await getEnhancedSearchResults(jobId);
      let key = [];
      let keyscount = [];
      let valuesofkey = [];
      for (let o in results) {
        let o1 = o;
        let o2 = results[o].values;
        key.push(o1);
        valuesofkey.push(o2);
        keyscount.push(results[o].size);
      }
      setSectionArray(key);
      setKeywordArray(valuesofkey);
      setSectionCountArray(keyscount);
      setEnhancedSearchResult(results)
      setEnhancedSearchLoading(false);
    }
    setEnhancedSearchLoading(true);
    fetchEnhancedSearchResults();
  }, []);

  const handleChangeOuter = (panel) => (event, isExpanded) => {
    setExpandedOuter(isExpanded ? panel : false);
  };

  const handleChangeInner = (panel, groupHighlight) => (event, isExpanded) => {
    setExpandedInner(isExpanded ? panel : false);
    setSelectedGroupEnhancedSearch(groupHighlight);
  };

  const handleClickEnhancedSearchResult = (list) => {
    setSelectedEnhancedSearch(list);
  };

  return (
    <>
      <div className="enhanced-search-container">
        <EnhancedSearchModal enhancedSearchResult={enhancedSearchResult} />

        {enhancedSearchLoading ? (
          <FadeLoader
            width={5}
            radius={2}
            margin={2}
            height={15}
            color={"#4183C5"}
            css={overrideSidebar}
            loading={enhancedSearchLoading}
          />
        ) : (
          <div className="enhancedsearch-overflow">
            {sectionArray &&
              sectionArray.map((outeritem, index) => {
                return (
                  <Accordion
                    key={outeritem}
                    className="accordian-outer-style"
                    expanded={expandedOuter === "panelouter-" + outeritem}
                    onChange={handleChangeOuter("panelouter-" + outeritem)}
                  >
                    <AccordionSummary
                      className="accordionSummary-height"
                      id={`panelouter${outeritem}bh-header`}
                      expandIcon={
                        <ExpandMoreIcon style={{ color: "#4183c5" }} />
                      }
                    >
                      <div className="full-width">
                        <div
                          className="accordian-outer-summary-title"
                          title={`${outeritem} (${
                            sectionCountArray[index]
                              ? sectionCountArray[index]
                              : 0
                          })`}
                        >
                          {outeritem} (
                          {sectionCountArray[index]
                            ? sectionCountArray[index]
                            : 0}
                          )
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div className="accordian-inner-container">
                        {keywordArray[index] &&
                          keywordArray[index].map((inneritem, i) => {
                            return (
                              <Accordion
                                key={i}
                                className="accordian-inner-style"
                                expanded={
                                  expandedInner ===
                                  "panelinner-" + Object.keys(inneritem)[0]
                                }
                                onChange={handleChangeInner(
                                  "panelinner-" + Object.keys(inneritem)[0],
                                  Object.values(inneritem)[0]
                                )}
                              >
                                <AccordionSummary
                                  expandIcon={
                                    <ExpandMoreIcon
                                      style={{ color: "#99A4A9" }}
                                    />
                                  }
                                  id={`panelouter${
                                    Object.keys(inneritem)[0]
                                  }bh-header`}
                                  className="accordian-innerbar"
                                >
                                  <div className="full-width">
                                    <div
                                      className="accordian-inner-summary-title"
                                      title={`${Object.keys(inneritem)[0]} (${
                                        Object.values(inneritem)[0].length
                                      })`}
                                    >
                                      {Object.keys(inneritem)[0]} (
                                      {Object.values(inneritem)[0].length})
                                    </div>
                                  </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <div className="full-width accordian-inner-container-display-area">
                                    {Object.values(inneritem)[0].length > 0 ? (
                                      Object.values(inneritem)[0].map(
                                        (list) => {
                                          return (
                                            <div
                                              key={list?.id}
                                              className={`accordian-inner-container-display ${
                                                selectedEnhancedSearch === list ? "enhancedsearch-result-active" : ""
                                              }`}
                                              onClick={() =>
                                                handleClickEnhancedSearchResult(
                                                  list
                                                )
                                              }
                                            >
                                              <div className="accordian-inner-container-display-header">
                                                Page {list?.pageNo}
                                              </div>
                                              <div
                                                title={
                                                  list?.annotationSpecificMessage
                                                }
                                                className="accordian-inner-container-display-text"
                                              >
                                                {
                                                  list?.annotationSpecificMessage
                                                }
                                              </div>
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      <div className="accordian-inner-container-display no-pointercss">
                                        <div
                                          className="accordian-inner-container-display-header"
                                          title={`No search result for ${
                                            Object.keys(inneritem)[0]
                                          }`}
                                        >
                                          No search result for{" "}
                                          {Object.keys(inneritem)[0]}
                                        </div>
                                        <div
                                          className="accordian-inner-container-display-header"
                                          title={`Use Basic PDF Search to search other related keywords apart from this.`}
                                        >
                                          Use Basic PDF Search to search other
                                          related keywords apart from this.
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </AccordionDetails>
                              </Accordion>
                            );
                          })}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
};

export default EnchancedSearch;